import { Box, Grid } from '@chakra-ui/react';
import { AlertOctagon } from 'lucide-react';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 24px;
`;

export const ErrorIcon = styled(AlertOctagon)`
  width: 72px;
  height: 72px;
  stroke: #053746;
  stroke-width: 1.75;
`;

export const ContentPanel = styled(Box).attrs({
  width: '75%',
  bg: 'white',
  borderWidth: 1,
  borderColor: 'gray.100',
  borderRadius: 16,
  px: { base: 6, md: 10 },
  py: { base: 8, md: 10 },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 6,
  boxShadow: 'sm',
})``;

export const IllustrationWrapper = styled(Box).attrs({
  width: '112px',
  height: '112px',
  borderRadius: 'full',
  bg: 'gray.100',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})``;

export const DetailsPanel = styled(Box).attrs({
  width: '75%',
  bg: 'gray.900',
  color: 'white',
  borderRadius: 16,
  px: { base: 4, md: 6 },
  py: { base: 4, md: 5 },
  boxShadow: 'sm',
})``;

export const DetailBlock = styled(Box).attrs({
  width: '100%',
  bg: 'rgba(255, 255, 255, 0.06)',
  borderRadius: 12,
  px: 4,
  py: 3,
  overflowX: 'auto',
  fontFamily: 'mono',
  fontSize: 'sm',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
})``;

export const MetadataGrid = styled(Grid).attrs({
  width: '100%',
  templateColumns: { base: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
  gap: 3,
})``;

export const SupportGrid = styled(Grid).attrs({
  width: '100%',
  templateColumns: {
    base: '1fr',
    md: 'repeat(auto-fit, minmax(220px, 1fr))',
  },
  gap: 3,
})``;

export const SupportCard = styled(Box).attrs({
  width: '100%',
  bg: 'gray.50',
  borderWidth: 1,
  borderColor: 'gray.100',
  borderRadius: 12,
  px: 4,
  py: 3,
})``;
